import React from "react";
import Addevent from "./Addevents";

const AddEventManager = (props) => {
  return <Addevent {...props} />;
};

export default AddEventManager;
